import { render, staticRenderFns } from "./OrderCreatorServiceSamplesInfo.vue?vue&type=template&id=c685e440&"
import script from "./OrderCreatorServiceSamplesInfo.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceSamplesInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorServiceSamplesInfo.vue?vue&type=style&index=0&id=c685e440&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports